import { createContext } from 'react'
export const RestContext = createContext({state: {}, actions: {}});